// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"308":"continueonpc","352":"onboarding","530":"simulation","817":"finished","962":"home"}[chunkId] + "." + {"308":"8cf54f0c","352":"2b982fee","530":"84cd2ac0","817":"adcd5b7c","962":"56ef926f"}[chunkId] + ".css";
};